import { gql } from '@apollo/client';

const ROLE_BASE_FRAGMENT = gql`
  fragment RolesScreenRole on VOLUNTEER_ActivityRoleType {
    activityRoleId
    name
    icon
    description
    canApply
    applicationMode
    allowReapply
    tasks {
      taskId
      title
    }
  }
`;

const ROLE_APPLICATION_FRAGMENT = gql`
  fragment RolesScreenRoleApplication on VOLUNTEER_RoleApplicationType {
    roleApplicationId
    status
    dateApplied
    dateActioned
    firstApprovedAt
    actionReason
    role {
      ...RolesScreenRole
    }
  }
  ${ROLE_BASE_FRAGMENT}
`;

export const GET_ROLES_SCREEN = gql`
  query GetRolesScreen($volunteerId: String!, $userId: String!) {
    vm {
      rolesAvailableForApplication(volunteerId: $volunteerId) {
        ...RolesScreenRole
      }
      myRoleApplications(volunteerId: $volunteerId) {
        ...RolesScreenRoleApplication
      }
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        activityRoles {
          ...RolesScreenRole
        }
      }
      profile(userId: $userId) {
        profileId
        completedTasks {
          completedTaskId
          task {
            taskId
          }
        }
      }
    }
  }
  ${ROLE_BASE_FRAGMENT}
  ${ROLE_APPLICATION_FRAGMENT}
`;
